import { IconWrapper } from '../runtime';
export default IconWrapper('s2t_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#5651E6"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#817CFF"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.2527 5.71875V8.15625C10.2527 8.72579 9.79098 9.1875 9.22144 9.1875C8.65189 9.1875 8.19019 8.72579 8.19019 8.15625V5.71875C8.19019 5.14921 8.65189 4.6875 9.22144 4.6875C9.79098 4.6875 10.2527 5.14921 10.2527 5.71875ZM6.31519 5.71875C6.31519 4.11367 7.61636 2.8125 9.22144 2.8125C10.8265 2.8125 12.1277 4.11367 12.1277 5.71875V8.15625C12.1277 9.76133 10.8265 11.0625 9.22144 11.0625C7.61636 11.0625 6.31519 9.76133 6.31519 8.15625V5.71875ZM5.18488 9H3.28125C3.65125 11.5867 5.69726 13.6327 8.28394 14.0027V15.5625H10.1589V14.0027C12.7456 13.6327 14.7916 11.5867 15.1616 9H13.258C12.8701 10.8213 11.2522 12.1875 9.31519 12.1875H9.12769C7.19067 12.1875 5.57274 10.8213 5.18488 9Z",
      "fill": "white"
    }
  })]);
});